import { ApplicationConfig } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { APP_NAME, COMPANY, ENVIRONMENT } from '@lx/shared/tokens';
import { importProvidersFrom } from '@angular/core';
import { BASE_PATH } from '@lx/shared/api/variables';
import { provideRouter } from '@angular/router';
import { quoteToolRoutes } from './app.routes';
import { QuoteFormLinkUrlsService } from '@lx/quote-tool/shared/data-access/quote';
import { LoggerModule, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { APPLICATION_CONFIGURATION_SERVICE } from '@lx/shared/app-config';
import { getApplicationInitializationProviders } from '@lx/shared/app-init/functions/get-application-initializers-providers.function';
import { getCoreProviders } from '@lx/shared/app-init/functions/get-core-providers.function';
import { getErrorHandlerProviders } from '@lx/shared/app-init/functions/get-error-handler-providers.function';
import { ApplicationConfigurationService } from './application-configuration.service';
import { httpErrorInterceptorFn } from '@lx/shared/errors';
import { getGoogleAnalyticsProvider } from '@lx/shared/app-init/functions/get-google-analytics-provider.function';
import { CustomisedNGXLoggerServerService } from '@lx/shared/app-init';
import { NoopGoogleAnalyticsDataLayerService } from '@lx/shared/google-analytics';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptors([httpErrorInterceptorFn])),
    provideRouter(quoteToolRoutes),
    importProvidersFrom(
      LoggerModule.forRoot(
        {
          level: NgxLoggerLevel.DEBUG,
          disableConsoleLogging: false,
          serverLogLevel: NgxLoggerLevel.ERROR,
        },
        {
          serverProvider: {
            provide: TOKEN_LOGGER_SERVER_SERVICE,
            useClass: CustomisedNGXLoggerServerService,
          },
        },
      ),
    ),
    QuoteFormLinkUrlsService,
    { provide: APPLICATION_CONFIGURATION_SERVICE, useClass: ApplicationConfigurationService },
    ...getApplicationInitializationProviders(environment),
    ...getCoreProviders(environment),
    ...getErrorHandlerProviders(),
    getGoogleAnalyticsProvider(NoopGoogleAnalyticsDataLayerService),
    { provide: ENVIRONMENT, useValue: {} },
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    { provide: COMPANY, useValue: environment.COMPANY },
    { provide: APP_NAME, useValue: 'esl-quick-quote-tool' },
  ],
};
